<template>
  <div>
    <transition name="dashboard">
      <div class="main-div">
        <div class="mb-2" v-if="!isScopedProductPage">
          <v-col>
            <v-row class="d-flex justify-center align-stretch">
              <v-col cols="12" md="6">
                <v-card min-height="15vh" class="white--text w-100" elevation="2" color="blue">
                  <v-card-text class="cardtext white--text">
                    <v-col>
                      <v-row class="d-flex justify-start">
                        <span style="font-size: large;" class="font-weight-bold"
                          >Status Bayar Perode {{ displayPeriode }}</span
                        >
                      </v-row>
                      <v-row v-if="loadingHeader" class="d-flex justify-space-around">
                        <v-col cols="12" class="d-flex justify-center">
                          <v-progress-circular :size="70" color="white" indeterminate></v-progress-circular>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="5">
                          <v-row>
                            <v-col></v-col>
                          </v-row>
                          <v-row>
                            <span style="font-size: medium;">Belum Dibayar</span>
                          </v-row>

                          <v-row>
                            <span style="font-size: medium;">Menunggu Konfirmasi</span>
                          </v-row>
                        </v-col>
                        <v-col offset="1" cols="1">
                          <v-row>
                            <v-col></v-col>
                          </v-row>
                          <v-row>
                            <span>:</span>
                          </v-row>

                          <v-row>
                            <span>:</span>
                          </v-row>
                        </v-col>
                        <v-col cols="5">
                          <v-row>
                            <v-col></v-col>
                          </v-row>
                          <v-row>
                            <span style="font-size: medium;">{{ header.not_requested }} Peserta</span>
                          </v-row>

                          <v-row>
                            <span style="font-size: medium;">{{ header.requested }} Peserta</span>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="6" v-if="!isAdmin">
                <v-card min-height="15vh" class="white--text w-100" elevation="2" color="blue">
                  <v-card-text class="cardtext white--text">
                    <v-col>
                      <v-row class="d-flex justify-start">
                        <span style="font-size: large;" class="font-weight-bold">Status Klaim</span>
                      </v-row>
                      <v-row v-if="loadingHeader" class="d-flex justify-space-around">
                        <v-col cols="12" class="d-flex justify-center">
                          <v-progress-circular :size="70" color="white" indeterminate></v-progress-circular>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="5">
                          <v-row>
                            <v-col></v-col>
                          </v-row>
                          <v-row>
                            <span style="font-size: medium;">Jumlah Pengajuan</span>
                          </v-row>
                          <v-row>
                            <span style="font-size: medium;">Belum Lengkap</span>
                          </v-row>
                        </v-col>
                        <v-col offset="1" cols="1">
                          <v-row>
                            <v-col></v-col>
                          </v-row>
                          <v-row>
                            <span>:</span>
                          </v-row>
                          <v-row>
                            <span>:</span>
                          </v-row>
                        </v-col>
                        <v-col cols="5">
                          <v-row>
                            <v-col></v-col>
                          </v-row>
                          <v-row>
                            <span style="font-size: medium;">{{ participantHeader.requested }} Peserta</span>
                          </v-row>
                          <v-row>
                            <span style="font-size: medium;"
                              >{{ participantHeader.incompleteClaim }} Peserta</span
                            >
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </div>
        <div class="search">
          <v-btn
            class="mr-5"
            v-if="!isAdmin && !isScopedProductPage"
            dark
            :color="addSubscriptionButtonColor"
            @click="handleAddSubscriptionClick()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <v-tooltip text="Tooltip">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                class="mr-5"
                v-if="!isAdmin"
                dark
                color="primary"
                @click="paidMultipleSubscription()"
              >
                <v-icon>mdi-cash-multiple</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="400" allow-overflow offset-x>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                Filter
              </v-btn>
            </template>
            <v-card>
              <v-autocomplete
                :loading="loadingCompany"
                v-if="isAdmin"
                :items="filter.company"
                v-model="filter.selectedCompany"
                class="px-5"
                label="Filter BMT"
                placeholder="BMT"
                item-value="value"
                item-text="text"
                single-line
                clearable
              ></v-autocomplete>
              <v-autocomplete
                :loading="loadingBranch"
                :items="filter.branch"
                v-if="isAdmin || isHeadquarters"
                v-model="filter.selectedBranch"
                class="px-5"
                label="Cabang BMT"
                placeholder="Cabang"
                item-value="value"
                item-text="text"
                single-line
                :clearable="isAdmin"
              ></v-autocomplete>

              <v-autocomplete
                :items="filter.list"
                v-model="filter.selected"
                class="px-5"
                label="Filter Periode"
                item-text="name"
                item-value="value"
                single-line
                @change="getAllSubscription()"
              ></v-autocomplete>
            </v-card>
          </v-menu>
          <v-select
            :items="filter.paidStatus"
            item-text="text"
            item-value="value"
            v-model="filter.selectedPaidStatus"
            style="max-width: 200px;"
            class="ml-3 mt-5"
            label="Status Pembayaran"
          >
          </v-select>
          <v-select
            :items="filter.claimStatus"
            item-text="text"
            item-value="value"
            v-model="filter.selectedClaimStatus"
            style="max-width: 200px;"
            class="ml-3 mt-5"
            label="Status Klaim"
          >
          </v-select>
          <v-select
            v-if="isScopedProductPage"
            :items="filter.paymentOrder"
            item-text="text"
            item-value="value"
            v-model="filter.selectedPaymentOrder"
            style="max-width: 200px;"
            class="ml-3 mt-5"
            label="Bayar Ke"
          >
          </v-select>

          <v-spacer></v-spacer>
          <!-- 
          <v-btn
            @click="generateReport(false)"
            v-if="isAdmin"
            :loading="isExcelLoading"
            class="mx-2 ml-2"
            color="green"
          >
            Laporan Kematian & Kebakaran
          </v-btn>

          <v-btn
            @click="generateReport(true)"
            v-if="isAdmin"
            :loading="isExcelLoading"
            class="mx-2 ml-2"
            color="primary"
          >
            Laporan Kebakaran
          </v-btn> -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                fab
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                class="mx-2"
                @click="isAdmin ? openExportForm() : generateReport()"
              >
                <v-icon>mdi-microsoft-excel</v-icon>
              </v-btn>
            </template>
            <span>Export Laporan Excel</span>
          </v-tooltip>
          <v-btn
            class="mx-2"
            fab
            small
            @click="
              table.search = ''
              getAllSubscription()
            "
            color="primary"
          >
            <v-icon>
              mdi-autorenew
            </v-icon>
          </v-btn>
          <v-text-field
            v-model="table.search"
            prepend-icon="mdi-magnify"
            class="input"
            label="Cari..."
            single-line
            hide-details
          ></v-text-field>
        </div>

        <v-data-table
          :headers="tableHeaders"
          :items="subscriptions"
          :loading="loading"
          :page.sync="table.pagination.page"
          :items-per-page="table.pagination.itemsPerPage"
          item-key="id"
          hide-default-footer
          height="500px"
          class="datatable pt-5"
          dense
        >
          <template v-slot:[`item.paidStatus`]="{ item }">
            <div v-if="item.paidStatus == 'requested'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-timer-outline
                  </v-icon>
                </template>
                <span>Menunggu konfirmasi</span>
              </v-tooltip>
            </div>

            <div v-if="item.paidStatus == 'rejected'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon key="item.paidStatus" v-bind="attrs" v-on="on" color="red">
                    mdi-close-outline
                  </v-icon>
                </template>

                <span>{{ item.paidDescription }}</span
                ><br />
                <span>Silahkan Ubah Data Peserta, tanpa perlu membuat peserta baru</span>
              </v-tooltip>
            </div>

            <div v-if="item.paidStatus == 'approved'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon key="item.paidStatus" v-bind="attrs" v-on="on" color="green">
                    mdi-check-outline
                  </v-icon>
                </template>

                <span>Sudah dibayar pada <br />{{ item.paidDate }}</span>
              </v-tooltip>
            </div>
            <div v-if="item.paidStatus == ''" :class="item.paidStatus == '' ? 'blink' : ''">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="red">
                    mdi-alert-box-outline
                  </v-icon>
                </template>

                <span>Belum dibayar</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.claimStatus`]="{ item }">
            <div v-if="item.claimStatus == 'requested'">
              <div v-if="item.claim && item.passedDate">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">
                      mdi-timer-outline
                    </v-icon>
                  </template>
                  <span>Menunggu konfirmasi</span>
                </v-tooltip>
              </div>
              <div v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="red">
                      mdi-timer-outline
                    </v-icon>
                  </template>
                  <span v-if="!item.claim && !item.passedDate"
                    >Lengkapi Tanggal kematian dan Nominal Pengajuan Santunan</span
                  >
                  <span v-if="!item.claim && item.passedDate">Lengkapi Nominal Pengajuan Santunan</span>
                  <span v-if="item.claim && !item.passedDate">Lengkapi Tanggl kematian</span>
                </v-tooltip>
              </div>
            </div>
            <div v-if="item.claimStatus == 'rejected'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="red">
                    mdi-close-outline
                  </v-icon>
                </template>
                <span>{{ item.claimDescription }}</span>
              </v-tooltip>
            </div>
            <div v-if="item.claimStatus == 'approved'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="green">
                    mdi-check-outline
                  </v-icon>
                </template>
                <span>Sudah diklaim</span>
              </v-tooltip>
            </div>
            <div v-if="item.claimStatus == ''">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="green">
                    mdi-alert-box-outline
                  </v-icon>
                </template>
                <span>Belum diklaim</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.ajsStatus`]="{ item }">
            <div v-if="item.asyki_certificate_number">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="green">
                    mdi-check-outline
                  </v-icon>
                </template>
                <span v-show="item.asyki_certificate_number"
                  >Sertifikat : {{ item.asyki_certificate_number }}</span
                >
                <br />
                <span v-show="item.asyki_policy_number">Polis : {{ item.asyki_policy_number }}</span>
                <br />
              </v-tooltip>
            </div>
            <div v-else-if="item.paidStatus == 'requested'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">
                    mdi-timer-outline
                  </v-icon>
                </template>
                <span>Menunggu proses pengiriman ke asyki dari sistem</span>
              </v-tooltip>
            </div>
            <div v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="red">
                    mdi-alert-box-outline
                  </v-icon>
                </template>
                <span>{{ item?.asyki_status?.message || 'Menunggu Pengajuan Pembayaran' }}</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu bottom origin="center center" transition="scale-transition">
              <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn icon color="primary" dark v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                      <v-icon dark>
                        mdi-menu
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Menu</span>
                </v-tooltip>
              </template>
              <v-list dense>
                <v-subheader>{{ item.memberName }}</v-subheader>
                <v-list-item @click="onClickFooter(0, item.id, item.id_company, item.id_member, false)">
                  <v-list-item-icon>
                    <v-icon>mdi-magnify</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Rincian data Iuran</v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadCertificate(item)">
                  <v-list-item-icon>
                    <v-icon>mdi-file-certificate-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Cetak Sertifikat</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="
                    (item.paidStatus == '' || item.paidStatus == 'rejected') &&
                      (item.claimStatus == '' || item.claimStatus != 'approved')
                  "
                  @click="onClickFooter(0, item.id, item.id_company, item.id_member, true)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Ubah data Iuran</v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="!isAdmin && ('', 'rejected').includes(item.paidStatus)"
                  @click="paidSubscription(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account-check-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Bayar Iuran </v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="!isAdmin && item.paidStatus != '' && item.claimStatus != 'approved'"
                  @click="claimSubscription(item, 'requested')"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account-check-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{
                    item.claimStatus != 'approved' ? 'Pengajuan Santunan' : 'Kelengkapan Santunan'
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="!isAdmin && item.paidStatus != '' && item.claimStatus != 'approved'"
                  @click="onClickFooter(2, item.id, item.id_company, item.id_member, true)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    Pelunasan
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.paidStatus != 'approved' && item.claimStatus != 'approved'"
                  @click="deleteSubscription(item)"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-account-off</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    Hapus/Batal Kepesertaan
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>

        <div class="footer">
          <div class="datatable-action">
            <v-pagination
              v-model="table.pagination.page"
              :length="pages"
              :total-visible="5"
              @input="getAllSubscription()"
            />
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-dialog
              persistent
              v-model="dialog"
              scrollable
              :max-width="selectedForm !== null ? formList[selectedForm].width : 0"
            >
              <subscription
                :id_subscription="selectedSubscription.id_subscription"
                :id_company="selectedSubscription.id_company"
                :id_member="selectedSubscription.id_member"
                :isSave="selectedSubscription.isSave"
                v-if="selectedForm == 0"
                @change-form="changeForm"
                @close-form="closeForm"
              />
              <subs-claim
                :id_subscription="selectedSubscription.id_subscription"
                :isSave="selectedSubscription.isSave"
                v-if="selectedForm == 1"
                @change-form="changeForm"
                @close-form="closeForm"
              />
              <subs-repayment
                :id_subscription="selectedSubscription.id_subscription"
                :isSave="selectedSubscription.isSave"
                v-if="selectedForm == 2"
                @change-form="changeForm"
                @close-form="closeForm"
              />
              <subs-export
                v-if="selectedForm == 3"
                :default-company="filter.selectedCompany"
                :default-payment-status="filter.selectedPaidStatus === 'all' ? '' : filter.selectedPaidStatus"
                :default-periode="filter.selected"
                @close-form="closeForm"
              />
            </v-dialog>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import Swal from 'sweetalert2'
import Constant from '@/const'
import Subscription from '../components/subscription/SubsInput'
import SubsClaim from '../components/subscription/SubsClaim'
import SubsRepayment from '../components/subscription/SubsRepayment'
import SubsExport from '../components/subscription/SubsExport'

import ConstantMixin from '@/constantMixin'

const _ = require('lodash')
const axios = require('axios')
const moment = require('moment')
const { jsPDF } = require('jspdf')

export default {
  components: {
    Subscription,
    SubsClaim,
    SubsRepayment,
    SubsExport
  },
  mixins: [ConstantMixin],
  data() {
    return {
      loading: true,
      loadingHeader: true,
      loadingCompany: false,
      loadingBranch: false,
      isExcelLoading: false,
      isCertificateLoading: false,
      isAdmin: false,
      subscriptions: [],
      subscriptionNewStatus: false,
      selectedSubscription: '',
      isHeadquarters: false,
      dialog: '',
      itemDialog: false,
      menu: false,
      filter: {
        selected: '',
        selectedCompany: '',
        selectedBranch: '',
        selectedPaidStatus: 'all',
        selectedClaimStatus: 'all',
        selectedPaymentOrder: 0,
        subscription: 0,
        total: 0,
        list: [],
        company: [],
        branch: [],
        paidStatus: [
          { text: 'Semua', value: 'all' },
          { text: 'Belum Dibayar', value: '' },
          { text: 'Menunggu Konfirmasi', value: 'requested' },
          { text: 'Dibayar', value: 'approved' }
        ],
        claimStatus: [
          { text: 'Semua', value: 'all' },
          { text: 'Pengajuan', value: 'requested' }
        ],
        // 0 berarti semua pembayaran; pilihan lain memfilter peserta pada pembayaran
        // ke berapa mereka berada.
        paymentOrder: [
          { text: 'Semua', value: 0 },
          { text: '1', value: 1 },
          { text: '2', value: 2 },
          { text: '3', value: 3 }
        ]
      },
      header: {
        not_requested: 0,
        requested: 0
      },
      participantHeader: {
        requested: 0,
        incompleteClaim: 0
      },
      emptyPaidStatusCount: 0,
      notRequestedPaidCount: 0,
      selectedForm: null,
      pages: 0,
      formList: [
        { name: 'Subscription', width: 1200 },
        { name: 'Claim', width: 1000 },
        { name: 'Repayment', width: 700 },
        { name: 'Export', width: 700 }
      ],
      table: {
        singleExpand: true,
        expanded: [],
        search: '',
        pagination: {
          descending: false,
          page: 1,
          itemsPerPage: 10,
          sortBy: ''
        }
      }
    }
  },
  computed: {
    // Diambil dari meta route, bukan dari path, supaya penambahan route produk
    // khusus lain cukup mendaftarkan meta tanpa mengubah komponen ini. Saat fitur
    // dimatikan (production) cakupan dikosongkan, sehingga halaman Peserta kembali
    // menampilkan semua produk dan route produk 303 — kalau dibuka langsung lewat URL
    // tanpa menu — berperilaku sama seperti halaman Peserta.
    productScope() {
      if (!Constant.productScope.enabled) return ''
      return _.get(this.$route, 'meta.productScope', '')
    },
    isScopedProductPage() {
      return this.productScope === 'include'
    },
    // Potongan query produk untuk endpoint /subscription. String kosong berarti
    // halaman tidak membatasi produk.
    productScopeQuery() {
      const { code, includeParam, excludeParam } = Constant.productScope
      if (this.productScope === 'include') return `&${includeParam}=${encodeURIComponent(code)}`
      if (this.productScope === 'exclude') return `&${excludeParam}=${encodeURIComponent(code)}`
      return ''
    },
    // Filter pembayaran ke hanya ada di halaman produk khusus, jadi paramnya tidak
    // ikut dikirim dari halaman Peserta.
    paymentOrderQuery() {
      if (!this.isScopedProductPage) return ''
      return `&${Constant.productScope.paymentOrderParam}=${this.filter.selectedPaymentOrder || 0}`
    },
    // Dihitung, bukan disimpan di data lalu di-unshift saat mounted: komponen ini
    // dipakai ulang oleh route Peserta dan Produk 303, sehingga susunan kolom harus
    // ikut berubah saat pindah menu tanpa menunggu mounted() terpanggil lagi.
    tableHeaders() {
      const headers = [{ text: 'Peserta', value: 'memberName', width: '100px', sortable: false }]

      if (this.isScopedProductPage) {
        headers.push(
          { text: 'Pembayaran Ke', value: 'paymentOrder', width: '100px', sortable: false },
          { text: 'Pembayaran Berikutnya', value: 'nextPaymentDate', width: '150px', sortable: false }
        )
      } else {
        headers.push({ text: 'Produk', value: 'productCode', width: '80px', sortable: false })
      }

      headers.push(
        { text: 'Tarif Iuran', value: 'percent', width: '100px', sortable: false },
        { text: 'Jumlah Iuran', value: 'nominal', width: '100px', sortable: false },
        { text: 'Bayar', value: 'paidStatus', width: '20px', sortable: false },
        { text: 'Klaim', value: 'claimStatus', width: '20px', sortable: false },
        { text: '', value: 'actions', width: '10px', sortable: false }
      )

      if (this.isAdmin) {
        headers.unshift({ text: 'BMT', value: 'companyName', width: '150px', sortable: false })
      } else if (this.isHeadquarters) {
        headers.unshift({ text: 'Cabang', value: 'branch', width: '150px' })
      }

      return headers
    },
    displayPeriode() {
      return moment(this.filter.selected)
        .locale('id')
        .format('MMMM YYYY')
    },
    addSubscriptionButtonColor() {
      return this.isAddSubscriptionRestrictionEnabled &&
        this.emptyPaidStatusCount > 0 &&
        this.isAllowedEmptyPaidStatusCheckDate()
        ? 'red'
        : 'primary'
    }
  },
  watch: {
    // `router-view` tidak memakai key dan kedua route Peserta/Produk 303 memakai
    // komponen ini, sehingga instance-nya dipakai ulang saat pindah menu dan
    // mounted() tidak terpanggil lagi. Perubahan cakupan produk karena itu diawasi
    // eksplisit di sini supaya daftarnya ikut dimuat ulang.
    productScope() {
      this.table.pagination.page = 1
      // Reset filter di bawah memicu watcher-nya sendiri yang sudah memuat ulang
      // daftar, jadi pemuatan di sini hanya dilakukan kalau filternya memang sudah
      // berada di posisi default.
      const willResetPaymentOrder = this.filter.selectedPaymentOrder !== 0
      this.filter.selectedPaymentOrder = 0
      if (!willResetPaymentOrder) this.getAllSubscription()
    },
    'table.search'() {
      this.searchData(this)
    },
    dialog(newValue) {
      if (!newValue) {
        this.selectedForm = null
      }
    },
    'filter.selectedCompany'(value) {
      this.table.pagination.page = 1
      this.getAllSubscription()
      // this.getAllSubscriptionHeader()
      this.getBranchCompany(value)
    },
    'filter.selectedBranch'(value) {
      this.table.pagination.page = 1
      this.getAllSubscription()
      // this.getAllSubscriptionHeader()
    },
    'filter.selectedPaidStatus'(value) {
      this.table.pagination.page = 1
      this.getAllSubscription()
      // this.getAllSubscriptionHeader()
    },
    'filter.selectedClaimStatus'(value) {
      this.table.pagination.page = 1
      this.getAllSubscription()
      // this.getAllSubscriptionHeader()
    },
    'filter.selectedPaymentOrder'() {
      this.table.pagination.page = 1
      this.getAllSubscription()
    }
  },
  created() {
    this.$socket.client.on('subcription', data => {
      this.getAllSubscription(true)
    })
    this.$socket.client.on('claim', data => {
      this.getAllSubscription(true)
    })
    this.$socket.client.on('payment', data => {
      this.getAllSubscription(true)
    })
  },

  mounted() {
    this.$nextTick(() => {
      if (_.toLower(this.$store.getters.userLoggedIn.role) == 'administrator') {
        this.isAdmin = true
      } else if (this.$store.getters.userLoggedIn.company.isHeadquarters) {
        this.isHeadquarters = this.$store.getters.userLoggedIn.company.isHeadquarters
        this.getBranchCompany(this.$store.getters.userLoggedIn.company.id)
      }

      this.filter.list = this.monthFilter()
      this.filter.selected = this.filter.list[0].value
      this.getAllCompany()

      this.getAllSubscription()
      this.getNotRequestedPaidCount()
      this.getAddSubscriptionRestriction()
      // this.openExportForm()
    })
  },
  methods: {
    // moment(undefined) jatuh ke tanggal hari ini, jadi nilai kosong/tidak valid
    // sengaja dipisahkan supaya tabel tidak menampilkan tanggal palsu.
    formatOptionalDate(value) {
      if (!value) return '-'

      const parsed = moment(value)
      return parsed.isValid() ? parsed.locale('id').format('DD MMMM YYYY') : '-'
    },
    isAllowedEmptyPaidStatusCheckDate(date = new Date()) {
      const year = date.getFullYear()
      const month = date.getMonth()
      const lastDayOfMonth = new Date(year, month + 1, 0)
      const dateOnly = new Date(year, month, date.getDate())
      const lastDateOnly = new Date(year, month, lastDayOfMonth.getDate())
      const firstDateOnly = new Date(year, month, 1)

      // Always allow the first day of the month.
      if (dateOnly.getTime() === firstDateOnly.getTime()) return true

      // Last day is Sunday: allow Friday, Saturday, Sunday.
      if (lastDayOfMonth.getDay() === 0) {
        const startDate = new Date(lastDateOnly)
        startDate.setDate(lastDateOnly.getDate() - 2)
        return dateOnly >= startDate && dateOnly <= lastDateOnly
      }

      // Last day is Saturday: allow Friday and Saturday.
      if (lastDayOfMonth.getDay() === 6) {
        const startDate = new Date(lastDateOnly)
        startDate.setDate(lastDateOnly.getDate() - 1)
        return dateOnly >= startDate && dateOnly <= lastDateOnly
      }

      // Other weekdays: only allow the exact last day of month.
      return dateOnly.getTime() === lastDateOnly.getTime()
    },
    async handleAddSubscriptionClick() {
      try {
        // Status pengaturan dibaca ulang di sini, bukan mengandalkan hasil saat halaman
        // dibuka, supaya perubahan konfigurasi tidak terlewat pada halaman yang sudah
        // lama terbuka tanpa refresh.
        const isRestrictionEnabled = await this.getAddSubscriptionRestriction()

        if (isRestrictionEnabled && this.isAllowedEmptyPaidStatusCheckDate()) {
          const idCompany = _.get(this.$store, 'getters.userLoggedIn.company.id', '')
          const response = await axios.get(
            Constant.apiUrl.concat('/subscription/company/', idCompany, '/has-empty-paid-status')
          )

          const unpaidCount = this.getHasEmptyPaidStatusCount(response.data)
          if (unpaidCount > 0) {
            await Swal.fire({
              icon: 'info',
              title: 'Terdapat iuran belum dibayar',
              text: `Terdapat ${unpaidCount} iuran peserta yang belum dibayar.`
            })
            this.filter.selectedPaidStatus = ''
          } else {
            this.onClickFooter(0, '', '', '', true)
          }
        } else {
          this.onClickFooter(0, '', '', '', true)
        }
      } catch (error) {
        if (error.response) {
          const message = _.get(error, 'response.data.pesan', 'Gagal memeriksa status pembayaran')
          Swal.fire({
            icon: 'error',
            title: 'Terjadi Kesalahan',
            text: message
          })
        } else if (error.request) {
          Swal.fire({
            icon: 'error',
            title: 'Terjadi Kesalahan',
            text: 'Tidak dapat menyambung ke server'
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Terjadi Kesalahan',
            text: 'Gagal memeriksa status pembayaran'
          })
        }
      }
    },
    getHasEmptyPaidStatusCount(payload) {
      const countCandidate = _.get(payload, 'data.count', _.get(payload, 'count', _.get(payload, 'data')))

      if (_.isNumber(countCandidate)) return countCandidate
      if (_.isArray(countCandidate)) return countCandidate.length
      if (_.isBoolean(countCandidate)) return countCandidate ? 1 : 0
      if (_.isPlainObject(countCandidate) && _.isNumber(countCandidate.count)) return countCandidate.count

      return Number(countCandidate) || 0
    },
    getRequestedClaimStatusSummary(payload) {
      const requestedCandidate = _.get(payload, 'data.count', _.get(payload, 'count', _.get(payload, 'data')))
      const incompleteCandidate = _.get(
        payload,
        'data.incomplete_count',
        _.get(payload, 'incomplete_count', _.get(payload, 'data.incomplete_count', 0))
      )

      const requested = this.getHasEmptyPaidStatusCount({ data: requestedCandidate })
      const incompleteClaim = this.getHasEmptyPaidStatusCount({ data: incompleteCandidate })

      return {
        requested,
        incompleteClaim
      }
    },
    setPageOne() {
      this.table.pagination.page = 1
    },
    searchData: _.debounce(v => {
      v.getAllSubscription()
      this.setPageOne()
    }, 650),

    getAllCompany() {
      this.loadingCompany = true
      this.runApiCalls(() => {
        axios.get(Constant.apiUrl.concat('/master/company?headquarters=1')).then(response => {
          if (response.status == 200) {
            const companyDataGet = response.data.data
            this.filter.company = companyDataGet
              .filter(v => v.name !== 'ADMINISTRATOR' && v.isActive)
              .map(company => {
                return {
                  value: _.get(company, '_id', '').toString(),
                  text: _.get(company, 'name', '')
                }
              })
          }
          this.loadingCompany = false
        })
      })
    },
    getBranchCompany(id_company) {
      this.loadingBranch = true
      this.runApiCalls(() => {
        if (id_company) {
          axios.get(Constant.apiUrl.concat(`/master/company/branch/${id_company}`)).then(response => {
            if (response.status == 200) {
              const companyDataGet = response.data.data
              this.filter.branch = companyDataGet
                .filter(v => v.name !== 'ADMINISTRATOR' && v.isActive)
                .map(company => {
                  return {
                    value: _.get(company, '_id', '').toString(),
                    text: _.get(company, 'headquarters.description', '')
                  }
                })
              if (this.isAdmin) {
                this.filter.branch.unshift({ value: this.filter.selectedCompany, text: 'PUSAT' })
              } else {
                this.filter.branch.unshift({
                  value: this.$store.getters.userLoggedIn.company.id,
                  text: 'PUSAT'
                })
                this.filter.selectedBranch = this.$store.getters.userLoggedIn.company.id
                this.filter.branch.unshift({
                  value: 'all',
                  text: 'SEMUA CABANG'
                })
              }
            }
            this.loadingBranch = false
          })
        } else {
          this.loadingBranch = false
          this.filter.selectedBranch = ''
          this.filter.branch = []
        }
      })
    },

    getAllSubscription(isSocketTrigger = false) {
      this.loading = !isSocketTrigger ? true : false

      let company = !this.isAdmin ? this.$store.getters.userLoggedIn.company.id : ''
      if (this.filter.selectedCompany && this.filter.selectedBranch == '')
        company = this.filter.selectedCompany
      if (this.filter.selectedBranch)
        company =
          this.filter.selectedBranch == 'Pusat'
            ? this.$store.getters.userLoggedIn.company.id
            : this.filter.selectedBranch

      let isHq = ''
      if (
        (this.isHeadquarters || this.isAdmin) &&
        !this.filter.selectedBranch &&
        this.filter.selectedBranch != this.filter.selectedCompany
      ) {
        isHq = '1'
        if (company == '') {
          company = this.filter.selectedCompany
        }
      }
      this.runApiCalls(() => {
        axios
          .get(
            Constant.apiUrl.concat(
              // '/subscription?page=',
              // this.table.pagination.page,
              // '&itemCount=',
              // this.table.pagination.itemsPerPage,
              // '&sort=',
              // '-timestamps.created_at',
              // '&company=',
              // company || '',
              // '&filter=',
              // this.filter.selected || '',
              // '&headquarters=',
              // this.isHeadquarters ? (this.filter.selectedBranch ? '' : '1') : '',
              // '&history=1'

              '/subscription?page=',
              this.table.pagination.page,
              '&itemCount=',
              this.table.pagination.itemsPerPage,
              '&sort=',
              '-timestamps.created_at',
              '&search=',
              this.table.search,
              '&company=',
              company || '',
              '&periode=',
              this.filter.selected || '',
              '&headquarters=',
              isHq,
              '&paidStatus=',
              this.filter.selectedPaidStatus,
              '&claimStatus=',
              this.filter.selectedClaimStatus,
              this.productScopeQuery,
              this.paymentOrderQuery
            )
          )
          .then(response => {
            if (response.status == 200) {
              const { data, length } = response.data

              this.pages = 0
              this.pages = Math.ceil(length / this.table.pagination.itemsPerPage)

              this.subscriptions = []
              this.subscriptions = data.map(subscription => {
                return {
                  id: subscription?._id.toString(),
                  subscriptionNumber: subscription?.subscription_number,
                  id_company: subscription?.id_company?._id,
                  companyName: subscription?.id_company?.name,
                  id_member: subscription?.id_member?._id,
                  memberName: subscription?.id_member?.name,
                  productName: _.get(subscription, 'id_product.name', ''),
                  productCode: _.get(subscription, 'id_product.code', ''),
                  // Dipakai kolom halaman produk khusus. Field-nya menyusul dari
                  // Backend; selama belum ada, barisnya tampil '-' alih-alih kosong.
                  paymentOrder: _.get(subscription, 'payment_order', '') || '-',
                  nextPaymentDate: this.formatOptionalDate(_.get(subscription, 'next_payment_date', '')),
                  branch: _.get(subscription, 'id_company.isHeadquarters', false)
                    ? 'Pusat'
                    : _.get(subscription, 'id_company.headquarters.description', ''),
                  plafond: this.getCurrency(_.get(subscription, 'plafond', '')),
                  periode: _.get(subscription, 'periode', 0),
                  claim: subscription.claim ? this.getCurrency(_.get(subscription, 'claim', 0)) : 0,
                  passedDate: _.get(subscription, 'passed_date', ''),
                  percent: _.get(subscription, 'tariff.percent', '')
                    .toString()
                    .concat(' %'),
                  nominal: this.getCurrency(_.get(subscription, 'tariff.nominal', 0)),
                  disbursement: moment(_.get(subscription, 'disbursement'))
                    .locale('id')
                    .format('D MMMM YYYY'),
                  paidStatus: _.get(subscription, 'paid_status.status', ''),
                  paidDescription: _.get(subscription, 'paid_status.description', ''),
                  claimStatus: _.get(subscription, 'claim_status.status', ''),
                  claimDescription: _.get(subscription, 'claim_status.description', ''),
                  claimDate: moment(_.get(subscription, 'claim_status.created_at'))
                    .locale('id')
                    .format('D MMMM YYYY'),
                  paidDate: moment(_.get(subscription, 'paid_status.created_at'))
                    .locale('id')
                    .format('D MMMM YYYY'),
                  createdAt: _.get(subscription, 'timestamps.created_at'),
                  asyki_certificate_number: _.get(subscription, 'asyki_certificate_number', ''),
                  asyki_status: _.get(subscription, 'asyki_status', {}),
                  asyki_policy_number: _.get(subscription, 'asyki_policy_number', '')
                }
              })

              this.loading = false
            } else {
              this.pages = 0
              this.subscriptions = []
              this.loading = false
            }
          })
          .catch(error => {
            this.pages = 0
            this.subscriptions = []
            this.loading = false
          })
          .finally(() => {
            this.getAllSubscriptionHeader()
          })
      })
    },
    getAllSubscriptionHeader() {
      try {
        this.loadingHeader = true
        let company = !this.isAdmin ? this.$store.getters.userLoggedIn.company.id : ''
        if (this.filter.selectedCompany) company = this.filter.selectedCompany
        if (this.filter.selectedBranch)
          company =
            this.filter.selectedBranch == 'Pusat'
              ? this.$store.getters.userLoggedIn.company.id
              : this.filter.selectedBranch

        this.runApiCalls(() => {
          const inProgressPaymentRequest = axios.get(
            Constant.apiUrl.concat(
              '/subscription/in-progress-payment?company=',
              company || '',
              '&periode=',
              this.filter.selected || '',
              this.productScopeQuery
            )
          )

          const emptyPaidStatusRequest = company
            ? axios.get(Constant.apiUrl.concat('/subscription/company/', company, '/has-empty-paid-status'))
            : Promise.resolve({ data: { data: { count: 0 } } })

          const requestedClaimStatusRequest = company
            ? axios.get(
                Constant.apiUrl.concat('/subscription/company/', company, '/has-requested-claim-status')
              )
            : Promise.resolve({ data: { data: { count: 0 } } })

          Promise.all([inProgressPaymentRequest, emptyPaidStatusRequest, requestedClaimStatusRequest])
            .then(([inProgressPaymentResponse, emptyPaidStatusResponse, requestedClaimStatusResponse]) => {
              this.header =
                inProgressPaymentResponse.status == 200
                  ? inProgressPaymentResponse.data.data
                  : {
                      not_requested: 0,
                      requested: 0
                    }

              this.emptyPaidStatusCount = this.getHasEmptyPaidStatusCount(emptyPaidStatusResponse.data)
              const claimSummary = this.getRequestedClaimStatusSummary(requestedClaimStatusResponse.data)
              this.participantHeader = {
                requested: claimSummary.requested,
                incompleteClaim: claimSummary.incompleteClaim
              }
            })
            .catch(() => {
              this.header = {
                not_requested: 0,
                requested: 0
              }
              this.participantHeader = {
                requested: 0,
                incompleteClaim: 0
              }
              this.emptyPaidStatusCount = 0
            })
            .finally(() => {
              this.loadingHeader = false
            })
        })
      } catch (error) {
      } finally {
        this.loadingHeader = false
      }
    },

    getNotRequestedPaidCount() {
      const idCompany = _.get(this.$store, 'getters.userLoggedIn.company.id', '')
      if (!idCompany) return

      this.runApiCalls(() => {
        axios
          .get(Constant.apiUrl.concat('/subscription/company/', idCompany, '/not-requested-paid-count'))
          .then(response => {
            if (response.status == 200) {
              this.notRequestedPaidCount = _.get(
                response,
                'data.data.count',
                _.get(response, 'data.count', 0)
              )
            }
          })
          .catch(() => {
            this.notRequestedPaidCount = 0
          })
      })
    },

    async checkUnpaidStatus() {
      const idCompany = _.get(this.$store, 'getters.userLoggedIn.company.id', '')
      if (!idCompany) return true

      try {
        const response = await axios.get(
          Constant.apiUrl.concat('/subscription/company/', idCompany, '/not-requested-paid-count')
        )
        const data = _.get(response, 'data.data', _.get(response, 'data', {}))

        if (data.result === false) {
          await Swal.fire({
            icon: 'info',
            title: 'Terdapat iuran belum dibayar',
            text: 'Terdapat iuran peserta yang belum diajukan pembayarannya.'
          })
          return false
        }
        return true
      } catch (error) {
        return true
      }
    },

    async checkAndTriggerPaid() {
      const idCompany = _.get(this.$store, 'getters.userLoggedIn.company.id', '')
      if (!idCompany) return

      try {
        const response = await axios.get(
          Constant.apiUrl.concat('/subscription/company/', idCompany, '/not-requested-paid-count')
        )
        const data = _.get(response, 'data.data', _.get(response, 'data', {}))

        if (data.current_month === 0 && data.prev_month === 0) {
          await axios.patch(Constant.apiUrl.concat('/master/company/', idCompany, '/trigger-paid'))
        }
      } catch (error) {
        // silent
      }
    },

    async paidSubscription(item) {
      try {
        const canProceed = await this.checkUnpaidStatus()
        if (!canProceed) return

        if (!this.isHeadquarters)
          Swal.fire({
            title: 'Pembayaran',
            text: 'Silahkan pilih metode pembayaran',
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            denyButtonColor: '#34eb58',
            confirmButtonText: 'Pusat',
            denyButtonText: `Cabang`,
            cancelButtonText: 'Batal'
          }).then(response => {
            if (response.isConfirmed || response.isDenied) {
              let isPaidFromBranch = null
              if (response.isConfirmed) isPaidFromBranch = false
              else if (response.isDenied) isPaidFromBranch = true

              Swal.fire({
                title: 'Apakah anda yakin?',
                text: `Pembayaran akan di lakukan oleh ${isPaidFromBranch ? 'Cabang' : 'Pusat'} ?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal'
              }).then(result => {
                if (result.isConfirmed) {
                  this.swalLoading()
                  this.runApiCalls(() => {
                    axios
                      .put(
                        Constant.apiUrl.concat(
                          '/subscription/status/',
                          item.id,
                          '?company=',
                          item.id_company
                        ),
                        {
                          paid: {
                            periode: {
                              month: moment()
                                .locale('id')
                                .format('MMMM'),
                              year: moment()
                                .locale('id')
                                .format('YYYY')
                            },
                            status: 'requested',
                            description: ''
                          },
                          staff: this.$store.getters.userLoggedIn.id,
                          isPaidFromBranch
                        }
                      )
                      .then(response => {
                        if (response.status === 200) {
                          this.$socket.client.emit('payment:update', {
                            company: this.$store.getters.userLoggedIn.company.name,
                            staff: this.$store.getters.userLoggedIn
                          })
                          this.subscriptions = []
                          this.getAllSubscription(false)
                          this.checkAndTriggerPaid()
                        }
                        this.swalToast(
                          'success',
                          `Pembayaran berhasil terdaftar ${isPaidFromBranch ? '' : 'di Pusat'}`
                        )
                      })
                      .catch(error => {
                        if (error.response) {
                          const message = error.response.data.pesan
                          Swal.fire({
                            icon: 'error',
                            title: 'Terjadi Kesalahan',
                            text: message
                          })
                        } else if (error.request) {
                          Swal.fire({
                            icon: 'error',
                            title: 'Terjadi Kesalahan',
                            text: 'Tidak dapat menyambung ke server'
                          })
                        } else {
                          // eslint-disable-next-line
                          console.log('Something happened in the middle of request')
                        }
                      })
                  })
                }
              })
            }
          })
        else
          Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Pastikan data sudah sesuai`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Batal'
          }).then(result => {
            if (result.isConfirmed) {
              this.swalLoading()
              this.runApiCalls(() => {
                axios
                  .put(
                    Constant.apiUrl.concat('/subscription/status/', item.id, '?company=', item.id_company),
                    {
                      paid: {
                        periode: {
                          month: moment()
                            .locale('id')
                            .format('MMMM'),
                          year: moment()
                            .locale('id')
                            .format('YYYY')
                        },
                        status: 'requested',
                        description: ''
                      },
                      staff: this.$store.getters.userLoggedIn.id,
                      isPaidFromBranch: false
                    }
                  )
                  .then(response => {
                    if (response.status === 200) {
                      this.$socket.client.emit('payment:update', {
                        company: this.$store.getters.userLoggedIn.company.name,
                        staff: this.$store.getters.userLoggedIn
                      })
                      this.subscriptions = []
                      this.getAllSubscription(false)
                      this.checkAndTriggerPaid()
                    }
                    this.swalToast('success', `Pembayaran berhasil terdaftar`)
                    // Swal.fire('Pembayaran', `Pembayaran berhasil terdaftar `, 'success')
                  })
                  .catch(error => {
                    if (error.response) {
                      const message = error.response.data.pesan
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: message
                      })
                    } else if (error.request) {
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: 'Tidak dapat menyambung ke server'
                      })
                    } else {
                      // eslint-disable-next-line
                      console.log('Something happened in the middle of request')
                    }
                  })
              })
            }
          })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: 'Tidak dapat menyambung ke server'
        })
      }
    },

    async paidMultipleSubscription() {
      try {
        const canProceed = await this.checkUnpaidStatus()
        if (!canProceed) return

        let body = {
          periode: {
            month: moment()
              .locale('id')
              .format('MMMM'),
            year: moment()
              .locale('id')
              .format('YYYY')
          },
          status: 'requested',
          description: '',
          staff: this.$store.getters.userLoggedIn.id,
          isPaidFromBranch: false
        }

        if (!this.isHeadquarters)
          Swal.fire({
            title: 'Pembayaran',
            text: 'Silahkan pilih metode pembayaran',
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            denyButtonColor: '#34eb58',
            confirmButtonText: 'Pusat',
            denyButtonText: `Cabang`,
            cancelButtonText: 'Batal'
          }).then(response => {
            if (response.isConfirmed || response.isDenied) {
              if (response.isDenied) body.isPaidFromBranch = true

              Swal.fire({
                title: 'Apakah anda yakin?',
                text: `Pembayaran akan di lakukan oleh ${body.isPaidFromBranch ? 'Cabang' : 'Pusat'} ?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal'
              }).then(result => {
                if (result.isConfirmed) {
                  this.swalLoading()
                  this.runApiCalls(() => {
                    axios
                      .post(
                        Constant.apiUrl.concat(
                          '/subscription/paid-all',
                          '?company=',
                          this.$store.getters.userLoggedIn.company.id
                        ),
                        body
                      )
                      .then(response => {
                        if ([200, 202].includes(response.status)) {
                          this.$socket.client.emit('payment:update', {
                            company: this.$store.getters.userLoggedIn.company.name,
                            staff: this.$store.getters.userLoggedIn
                          })
                          this.subscriptions = []
                          if (response.status === 200) {
                            this.getAllSubscription(false)
                            this.checkAndTriggerPaid()
                          }
                        }
                        this.swalToast(
                          'success',
                          response.status === 202
                            ? 'Pengajuan pembayaran sedang diproses'
                            : `Pembayaran berhasil terdaftar ${body.isPaidFromBranch ? '' : 'di Pusat'}`
                        )
                      })
                      .catch(error => {
                        if (error.response) {
                          const message = error.response.data.pesan
                          Swal.fire({
                            icon: 'error',
                            title: 'Terjadi Kesalahan',
                            text: message
                          })
                        } else if (error.request) {
                          Swal.fire({
                            icon: 'error',
                            title: 'Terjadi Kesalahan',
                            text: 'Tidak dapat menyambung ke server'
                          })
                        } else {
                          // eslint-disable-next-line
                          console.log('Something happened in the middle of request')
                        }
                      })
                  })
                }
              })
            }
          })
        else
          Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Pastikan data sudah sesuai`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Batal'
          }).then(result => {
            if (result.isConfirmed) {
              this.swalLoading()
              this.runApiCalls(() => {
                axios
                  .post(
                    Constant.apiUrl.concat(
                      '/subscription/paid-all',
                      '?company=',
                      this.$store.getters.userLoggedIn.company.id
                    ),
                    body
                  )
                  .then(response => {
                    if ([200, 202].includes(response.status)) {
                      this.$socket.client.emit('payment:update', {
                        company: this.$store.getters.userLoggedIn.company.name,
                        staff: this.$store.getters.userLoggedIn
                      })
                      this.subscriptions = []
                      if (response.status === 200) {
                        this.getAllSubscription(false)
                        this.checkAndTriggerPaid()
                      }
                    }
                    this.swalToast(
                      'success',
                      response.status === 202
                        ? 'Pengajuan pembayaran sedang diproses'
                        : 'Pembayaran berhasil terdaftar'
                    )
                    // Swal.fire('Pembayaran', `Pembayaran berhasil terdaftar `, 'success')
                  })
                  .catch(error => {
                    if (error.response) {
                      const message = error.response.data.pesan
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: message
                      })
                    } else if (error.request) {
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: 'Tidak dapat menyambung ke server'
                      })
                    } else {
                      // eslint-disable-next-line
                      console.log('Something happened in the middle of request')
                    }
                  })
              })
            }
          })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: 'Tidak dapat menyambung ke server'
        })
      }
    },
    deleteSubscription(item) {
      try {
        Swal.fire({
          title: 'Anda yakin akan membatalkan ?',
          text: `Data tidak bisa dikembalikan`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        })
          .then(result => {
            if (result.value) {
              this.swalLoading()
              this.runApiCalls(() => {
                axios
                  .post(Constant.apiUrl.concat('/subscription/delete/', item.id))
                  .then(() => {
                    this.$socket.client.emit('claim:update', {
                      company: this.$store.getters.userLoggedIn.company.name,
                      staff: this.$store.getters.userLoggedIn
                    })
                    // Swal.fire('Berhasil!', 'Peserta berhasil dibatalkan', 'success')
                    this.swalToast('success', 'Peserta berhasil dibatalkan')
                    this.getAllSubscription(false)
                  })
                  .catch(error => {
                    if (error.response) {
                      const message = error.response.data.pesan
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: message
                      })
                    } else if (error.request) {
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: 'Tidak dapat menyambung ke server'
                      })
                    } else {
                      // eslint-disable-next-line
                      console.log('Something happened in the middle of request')
                    }
                  })
              })
            }
          })
          .catch(error => {
            if (error.response) {
              const message = error.response.data.pesan
              Swal.fire({
                icon: 'error',
                title: 'Terjadi Kesalahan',
                text: message
              })
            } else if (error.request) {
              Swal.fire({
                icon: 'error',
                title: 'Terjadi Kesalahan',
                text: 'Tidak dapat menyambung ke server'
              })
            } else {
              // eslint-disable-next-line
              console.log('Something happened in the middle of request')
            }
          })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: 'Tidak dapat menyambung ke server'
        })
      }
    },
    claimSubscription(item, claimStatus) {
      if (item.claimStatus != 'approved') {
        try {
          Swal.fire({
            title: 'Anda Yakin ?',
            text: `Pengajuan santunan untuk ${item.memberName}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then(result => {
            if (result.value) {
              this.swalLoading()
              this.runApiCalls(() => {
                axios
                  .put(
                    Constant.apiUrl.concat('/subscription/status/', item.id, '?company=', item.id_company),
                    {
                      claim: {
                        periode: {
                          month: moment()
                            .locale('id')
                            .format('MMMM'),
                          year: moment()
                            .locale('id')
                            .format('YYYY')
                        },
                        status: claimStatus,
                        description: ''
                      },
                      staff: this.$store.getters.userLoggedIn.id
                    }
                  )
                  .then(response => {
                    if (response.status === 200) {
                      this.$socket.client.emit('claim:update', {
                        company: this.$store.getters.userLoggedIn.company.name,
                        staff: this.$store.getters.userLoggedIn
                      })
                      this.swalToast('success', `Pengajuan santunan berhasil terdaftar`)
                      this.getAllSubscription(false)
                      this.onClickFooter(1, item.id, item.id_company, item.id_member, true)
                    }
                  })
                  .catch(error => {
                    if (error.response) {
                      const message = error.response.data.pesan
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: message
                      })
                    } else if (error.request) {
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: 'Tidak dapat menyambung ke server'
                      })
                    } else {
                      // eslint-disable-next-line
                      console.log('Something happened in the middle of request')
                    }
                  })
              })
            }
          })
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Terjadi Kesalahan',
            text: 'Tidak dapat menyambung ke server'
          })
        }
      } else this.onClickFooter(1, item.id, item.id_company, item.id_member, true)
    },
    async downloadCertificate(data) {
      try {
        this.isCertificateLoading = true

        await this.generateCertificate({
          id_subscription: data.id,
          company: data.companyName,
          member: data.memberName,
          staff: this.$store.getters.userLoggedIn.name
        })
        this.isCertificateLoading = false
      } catch (error) {
        this.isCertificateLoading = false
        Swal.fire({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: error
        })
      }
    },
    generateReport(type = 'general') {
      try {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'info',
          title: 'Sedang mengunduh laporan mohon ditunggu...',
          showConfirmButton: false,
          timerProgressBar: true,
          timer: 5000
        })
        this.isExcelLoading = true
        let isHq = ''
        if (
          (this.isHeadquarters || this.isAdmin) &&
          !this.filter.selectedBranch &&
          this.filter.selectedBranch != this.filter.selectedCompany
        )
          isHq = '1'

        let company = !this.isAdmin ? this.$store.getters.userLoggedIn.company.id : ''
        if (this.filter.selectedCompany) company = this.filter.selectedCompany
        if (this.filter.selectedBranch)
          company =
            this.filter.selectedBranch == 'Pusat'
              ? this.$store.getters.userLoggedIn.company.id
              : this.filter.selectedBranch

        this.runApiCalls(() => {
          const fileLink = document.createElement('a')
          fileLink.href = Constant.apiUrl.concat(
            `/reporting/xlsx?`,
            `company=${this.$store.getters.userLoggedIn.company.name}`,
            `&filtercompany=${company}`,
            `&periode=${this.filter.selected}`,
            `&id_company=${!this.isAdmin ? this.$store.getters.userLoggedIn.company.id : ''}`,
            `&isheadquarter=${isHq}`,
            `&exporttype=${type}`
          )
          fileLink.click()
          this.isExcelLoading = false
        })
      } catch (error) {
        this.isExcelLoading = false
        Swal.fire({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: error
        })
      }
    },

    openExportForm() {
      this.dialog = true
      this.selectedForm = 3
    },

    onClickFooter(index, id_subscription, id_company, id_member, isSave) {
      this.selectedSubscription = {
        id_subscription,
        id_company,
        id_member,
        isSave
      }
      switch (index) {
        default:
          this.changeForm(index)
          break
      }
      this.dialog = true
    },

    changeForm(item) {
      this.selectedForm = item
    },
    closeForm() {
      this.dialog = false
      this.getAllSubscription()
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-enter {
  opacity: 0;
  transform: translateX(-100px);
}

.dashboard-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

.dashboard-enter-active {
  transition: all 0.3s ease-in;
}

.main-div {
  margin: 10px auto;
  width: 90%;
}

h1 {
  font-size: 1.5em;
  text-align: left;
}

.filter-bmt {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  right: 0;
}

.search {
  // display: flex;
  // position: relative;
  // align-items: center;
  // justify-content: flex-end;
  // right: 0;
}

.input {
  max-width: 25%;
}

.autocomplete {
  max-width: 14%;
  margin-right: 2%;
}

.filter {
  position: relative;
  top: 10px;
  left: 5%;
}

.label {
  position: relative;
  margin-right: 10%;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
}

.datatable {
  max-height: 400px;
  margin-bottom: 20px;

  &::-webkit-scrollbar {
    width: 3px;
    background-color: rgb(163, 163, 163);
  }

  &::-webkit-scrollbar-thumb {
    width: 3px;
    background-color: black;
  }

  &.row-datatable {
    border: none !important;

    &.in-process {
      border-left: 10px solid $primary-color !important;
    }

    &.finished {
      border-left: 10px solid #30cd72 !important;
    }
  }

  .detail-patient {
    display: grid;
    grid-template-columns: 105px minmax(165px, 170px) minmax(200px, 175px);
    grid-template-rows: minmax(15px, 20px) 35px;
    grid-template-areas:
      '. no_reg name no_rm payment poli_type'
      '. no_reg name no_rm payment poli_type';
    border: none !important;
    text-align: left;
    color: #707070;

    &:hover {
      background: none !important;

      & > * {
        background: none !important;
      }
    }

    &.in-process {
      border-left: 5px solid $primary-color !important;
    }

    &.finished {
      border-left: 5px solid #30cd72 !important;
    }

    .poli-type {
      color: black;
    }
  }

  .detail-footer {
    color: #a9b1ba;
    // display: grid;
    grid-template-columns: repeat(5, 100px);
    grid-template-rows: 10px;
    grid-column-gap: 50px;
    // background-color: #f2f3f5;
    // padding: 50px;
    padding-left: 80%;
    justify-content: flex-end;

    // font-size: 1.3rem;
    .item {
      margin-right: 20px;
    }
  }
}

.cardtext {
  margin-left: 5px;
  padding-top: 5px;
  text-align: start;
}

@media only screen and (max-width: 1120px) {
  .detail-patient {
    grid-template-columns:
      125px minmax(152px, 1fr) minmax(100px, 112px) minmax(100px, 105px) minmax(160px, 162px)
      minmax(120px, 125px);
  }
}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>
